import React from "react";
import { Helmet } from "react-helmet";

import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import BlockGallery from "../sections/BlockGallery";
import CoverFlowGallery from "../sections/CoverFlowGallery";
import GreenBlockSection from "../sections/GreenBlockSection";
import Contact from "../sections/Contact";
// import specialsData from "../home/specialsData";
// import Specials from "../sections/Specials";

const About = () => {
  return (
    <div>
      <Helmet>
        <title>Décor & Floral Services | The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"Our in-house floral and décor specialists will take your dream event and make it a beautiful reality."}
        ></meta>
      </Helmet>

      <Header
        bgImg={"/images/floral-header-4.jpg"}
        headText={"FLORALS AT SHEPSTONE GARDENS"}
      />

      {/* <LineSeparator noLine />
      <Specials specialsList={specialsData} /> */}

      <LineSeparator noLine />
      <LineSeparator noLine />

      <GreenBlockSection
        headText={"day"}
        subHeadText={"A picture perfect"}
      >
        <div className={"three-columns"}>
          <p className={"venue-intro-text"}>
            Our incredible in-house décor and floral team understand how to flawlessly blend your chosen wedding style with the breathtaking surroundings of Shepstone Gardens and The Great Hall, bringing your dream look to life.
          </p>
          <p className={"venue-intro-text"}>
            Megan and her team do not only create flawless, picturesque moments for your special day, but translate your dream into reality. Walking the journey alongside you, they will guide and inspire every step of the way.
          </p>
          <p className={"venue-intro-text"}>
            A team that combines their love for the industry and floral art, with their appreciation and respect for each couple and their unique vision. You have a beautiful story to tell, and they are here to help you write this chapter.
          </p>
        </div>
      </GreenBlockSection>

      <LineSeparator noLine />

      <BlockGallery
        images={[
          { src: "/images/florals/SG_florals_june_2026_01.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_04.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_05.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_10.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_11.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_12.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_17.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_19.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_20.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_21.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_22.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_23.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_24.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_25.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_26.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_30.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_31.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_32.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_34.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_37.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_40.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_42.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_43.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_45.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_46.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_47.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_52.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_54.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_56.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_57.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_60.jpg", alt: "Flowers at Shepstone Gardens and The Great Hall" },
        ]}
      />

      <CoverFlowGallery
        images={[
          { src: "/images/florals/SG_florals_june_2026_02.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_03.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_06.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_07.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_08.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_09.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_13.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_15.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_16.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_18.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_27.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_28.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_29.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_33.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_35.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_36.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_38.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_39.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_41.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_44.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_48.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_49.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_50.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_51.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_53.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_55.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_58.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_59.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
          { src: "/images/florals/SG_florals_june_2026_61.jpg", alt: "A wedding floral arrangement at Shepstone Gardens & The Great Hall" },
        ]}
      />

      <LineSeparator noLine />
      <LineSeparator />
      <Contact />
    </div>
  );
};

export default About;

